import React from 'react';
import { Box, Button, Input, Stack, Text } from '@chakra-ui/react';
import { useFormik } from 'formik';
import { usePressEnter } from 'Hooks';
import { useCodeScan } from 'Hooks/useCodeScan';
import { CodeType } from 'Types/Enums';

interface ISurveyModalProp {
	onClose: () => void;
}

export const SurveyModal = ({ onClose }: ISurveyModalProp) => {
	const { handleScan, isLoading } = useCodeScan({ onScanComplete: onClose });

	const { handleChange, handleSubmit } = useFormik({
		initialValues: {
			webCode: '',
		},
		onSubmit: ({ webCode }) => {
			handleScan(webCode, CodeType.Webcode);
		},
	});

	usePressEnter(handleSubmit);

	return (
		<Stack pt={['80px', '40px']} px={['20px', '20px']} pb={['', '30px']} spacing={'28px'}>
			<Text fontSize={['20px','16px']} mb={['40px', 0]} fontWeight={600} color={'#121B26'}>
				Scan a webcode
			</Text>
			<Box pb={['40px', 0]}>
				<Input
					variant='flushed'
					placeholder='Enter webcode'
					onChange={handleChange}
					name='webCode'
					_focus={{
						outline: 'none',
					}}
				/>
			</Box>
			
			<Button  h={['50px']} variant={'primary'} isLoading={isLoading} onClick={() => handleSubmit()} borderRadius={'10px'}>
				Scan
			</Button>
		</Stack>
	);
};
